namespace GeniuzPOS.InventoryReport {
    export interface IcReport04Row {
        Id?: string;
        Grouptype?: string;
        GroupCode?: string;
        GroupName?: string;
        QtyOnHand?: number;
        StockCostValue?: number;
    }

    export namespace IcReport04Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Grouptype';
        export const localTextPrefix = 'InventoryReport.IcReport04';
        export const deletePermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const insertPermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const readPermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const updatePermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';

        export declare const enum Fields {
            Id = "Id",
            Grouptype = "Grouptype",
            GroupCode = "GroupCode",
            GroupName = "GroupName",
            QtyOnHand = "QtyOnHand",
            StockCostValue = "StockCostValue"
        }
    }
}
